import { useRouter } from 'next/router'
import {
  GqlPostsQuery,
  OrderDirection,
  PostOrderField,
  useGqlPostsQuery,
} from 'generated/graphql.community'

interface UseGetReviewPostsReturnType {
  reviewPostsData: GqlPostsQuery['posts']
}

type TUseGetReviewPostsFn = (params: {
  boardID: string
  topicID?: string
}) => UseGetReviewPostsReturnType

const useGetReviewPosts: TUseGetReviewPostsFn = ({ boardID, topicID }) => {
  const router = useRouter()

  const { query } = router

  const { data } = useGqlPostsQuery({
    variables: {
      filterBy: {
        boardID,
        topicID,
      },
      orderBy: {
        direction: OrderDirection.DESC,
        field: PostOrderField.CREATED_AT,
      },
      pagination: {
        page: query.page ? Number(query.page) : 1,
        pageSize: 6,
      },
    },
    fetchPolicy: 'network-only',
  })

  return {
    reviewPostsData: data?.posts,
  }
}

export default useGetReviewPosts
